(function () {
  'use strict';

  /* @ngdoc object
   * @name bmfexport
   * @description
   *
   */
  angular
    .module('finance.rksv', [
      'ui.router',
      'ui.bootstrap'
    ]);
}());
